/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Author from './Author/index'
import Content from './Content/index'
import Indicator from './Indicator/index'
import Info from './Info/index'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/Events/Content/Event/Note/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let moveResourcesNoteIdsValueData = fromData.useDataValue({ viewPath,
context: 'move_resources',
path: 'note_ids',
})
let noteIdValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: '_id',
})
let aggregateData = fromAggregate.includes(moveResourcesNoteIdsValueData, noteIdValueData)
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let dtColorsOrange100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.100'
        })
let dtColorsOrange300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.300'
        })
let dtColorsOrange900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="move_resources.note_ids"
 data="note._id"
 aggregate="/Data/aggregate.js includes"
 value={aggregateData}
 onChange={onChange}
>
{childProps => (
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
)}
</TysiaCheckbox>
<Indicator
  viewPath={`${viewPath}/Indicator`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bc-2-Z1Yf8zk': dtColorsOrange100,'--bc-3-Z1Yf8zk': dtColorsOrange300,'--bblr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--sc-8-Z1Yf8zk': dtColorsOrange900}}
 className={`views-block ${styles.Horizontal1}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
<div
  data-testid="Content1.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mr-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Author
  viewPath={`${viewPath}/Author`}
/>
<Info
  viewPath={`${viewPath}/Info`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}